import { Switchboard } from "../events";
export class Dispatcher {
    constructor(map, layer, ctx_mgr) {
        this.map = map;
        this.layer = layer;
        this.ctx_mgr = ctx_mgr;
        this.actions = [];
        this.broadcaster = Switchboard.get_emitter("MOVEMENT");
        this.failure_result = {
            context: '',
            center: false,
            zoom: false,
            fail: true
        };
    }
    add_actions(...actions) {
        actions.forEach(a => a.set_ctx_hook(() => this.ctx_mgr.context));
        this.actions.push(...actions);
    }
    dispatch(message) {
        return this.map.loaded().then(() => this._dispatch(message));
    }
    change_ctx(requested) {
        if (requested === 'revert')
            return this.ctx_mgr.revert();
        if (requested === 'set-group') {
            if (this.ctx_mgr.context.isSomeAnd(c => c.name === 'group'))
                return;
            this.ctx_mgr.update_context('set');
            return;
        }
        this.ctx_mgr.update_context(requested);
    }
    async _dispatch(message) {
        if (!message) {
            this.map.ready();
            return this.failure_result;
        }
        const action = this.actions.find(a => a.name === message.command);
        if (!action) {
            this.map.ready();
            return this.failure_result;
        }
        const result = await action.execute(message);
        if (result.isNone()) {
            this.map.ready();
            return this.failure_result;
        }
        let action_result = result.unwrap();
        if (action_result.fail) {
            this.map.ready();
            return action_result;
        }
        if (action_result.context)
            this.change_ctx(action_result.context);
        if (action_result.center)
            this.broadcaster.emit("center", await this.layer.get_feature_center_by_id(this.layer.clicked));
        if (action_result.zoom)
            this.broadcaster.emit("zoom", this.ctx_mgr.context_name.unwrapOr(""));
        this.map.ready();
        return action_result;
    }
}
